// extracted by mini-css-extract-plugin
export default {"Loader":"Loader_Loader__wqo9C","load7":"Loader_load7__sgcxk"};